<template>
  <div class="">
    <!-- Título principal -->
    <div class="my-6">
      <h1 class="text-2xl font-bold text-gray-800 mb-2">
        Actualizar expiración de pago
      </h1>
    </div>

    <!-- Layout en dos columnas sin v-row -->
    <div class="grid grid-cols-2 xl:grid-cols-2 gap-6 xl:gap-8">
      <!-- Columna izquierda - Documentación -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Información del endpoint -->
        <div class="bg-white rounded-lg border border-gray-200 p-4 xl:p-6">
          <h3 class="text-lg xl:text-xl font-semibold flex items-center">
            <span
              class="bg-orange-100 text-orange-800 px-2 py-1 rounded text-sm xl:text-base font-mono mr-3"
              >PUT</span
            >
            <span class="text-wrap text-xs">
              https://sb-wee.ar/administracion/update-pago-expiration?uuid=93a03066-83f7-41a0-8b91-11062b813258&fecha_hora_expiracion=10-05-2025
              12:00:00</span
            >
          </h3>
        </div>

        <!-- Parámetros -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Request
        </h4>

        <!-- Headers Table -->
        <DynamicTable
          title="Headers"
          :headers="headersActualizarPago"
          :data="headersData"
          height="auto"
        />

        <DynamicTable
          title="Path parameters"
          :headers="bodyConfig"
          :data="bodyParameters"
          height="auto"
        />

        <!-- Response -->
        <h4 class="font-semibold mb-3 xl:mb-4 text-base xl:text-lg">
          Response
        </h4>

        <DynamicTable
          title="Atributos del objeto de la respuesta."
          :headers="responseHeaders"
          :data="responseData"
          height="auto"
        />
      </div>

      <!-- Columna derecha - Ejemplos de código -->
      <div class="space-y-4 xl:space-y-6">
        <!-- Request Example -->
        <div class="bg-white rounded-lg border border-gray-200 p-3 xl:p-6">
          <h4 class="text-lg xl:text-xl font-semibold mb-3 flex items-center">
            Headers
          </h4>
          <span class="text-black">
            <p>
              <code class="text-black">Content-Type: application/json</code>
            </p>
            <p>
              <code class="text-black">{{ apikeyExample }}</code>
            </p>
          </span>
        </div>

        <CodeBlock
          title="Example response"
          :code="responseExample"
          language="json"
          status="success"
          :is-large="true"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DynamicTable from "../shared/DynamicTable.vue";
import CodeBlock from "../shared/CodeBlock.vue";

export default {
  name: "ConsultarEstadoPago",
  components: {
    DynamicTable,
    CodeBlock,
  },
  data() {
    return {
      // Configuración de headers para la tabla de Headers
      headersActualizarPago: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "pattern", label: "PATTERN" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de headers
      headersData: [
        {
          atributo: "Content-Type",
          tipo: "String",
          requerido: "Sí",
          pattern: "application/json",
          descripcion:
            "El tipo MIME del contenido del cuerpo enviado. Por defecto JSON es Unicode UTF-8. No se debe configurar otro charset.",
        },
        {
          atributo: "apikey",
          tipo: "String",
          requerido: "Sí",
          pattern: "API Key",
          descripcion: "ApiKey de la cuenta a la que pertenece el pago.",
        },
      ],

      // Configuración de headers para la tabla de Body
      bodyConfig: [
        { key: "atributo", label: "ATRIBUTO", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "requerido", label: "REQUERIDO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      // Datos de parámetros del body
      bodyParameters: [
        {
          atributo: "uuid",
          tipo: "String",
          requerido: "Sí",
          descripcion: "UUID del pago.",
        },
        {
          atributo: "fecha_hora_expiracion",
          tipo: "String",
          requerido: "Sí",
          descripcion:
            "Fecha y hora de expiración. Formato DD-MM-YYYY HH:mm:ss",
        },
      ],

      // Response

      responseHeaders: [
        { key: "atributo", label: "atributo", isCode: true },
        { key: "tipo", label: "TIPO" },
        { key: "descripcion", label: "DESCRIPCIÓN" },
      ],

      responseData: [
        {
          atributo: "data",
          tipo: "Object",
          descripcion: "Datos de respuesta.",
        },
        {
          atributo: "message",
          tipo: "String",
          descripcion: "Mensaje de la respuesta.",
        },
        {
          atributo: "status",
          tipo: "Boolean",
          descripcion: "Estado de la respuesta.",
        },
      ],

      // Ejemplos de código
      apikeyExample: "apiKey: {{ apikey }}",

      responseExample: ` {
        "data": {
          "external_reference": "5976282",
          "fecha_hora_expiracion": "2025-04-30T13:38:00Z",
          "payer_email": "correo@gmail.com",
          "payer_name": "NOMBRE APELLIDO",
          "uuid": "3fe900c4-fc79-4c36-84da-0dfb3b181133"
      },
          "message": "La fecha de expiración del pago se actualizó correctamente",
          "status": true
      }`,
    };
  },
};
</script>

<style scoped>
/* Responsive adjustments para el grid */
@media (max-width: 1279px) {
  .grid-cols-1.xl\:grid-cols-2 {
    grid-template-columns: 1fr;
  }
}
</style>
